import React, { useState, useRef, useEffect } from 'react';

function Pricing({ onDataUpdate }) {
  const [amount, setAmount] = useState(0);
  const [taxable, setTaxable] = useState('');
  const [options, setOptions] = useState({
    rollUpPrice: false,
    suppressWhenZero: false,
    suppressOnReports: false,
  });
  const [pricePer, setPricePer] = useState('');

  const previousDataRef = useRef({ amount, taxable, pricePer, options });


  const handleChange = (event) => {
    setOptions({ ...options, [event.target.name]: event.target.checked });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic here
  };

  const handleProcedureChange = (event) => {
    setTaxable(event.target.value);
    // Handle procedure change logic here
  };

  const handlePricePerChange = (event) => {
    setPricePer(event.target.value);
  };

  useEffect(() => {
    // Prepare the current data object
    const currentData = { amount, taxable, pricePer, options };

    // Check if the current data is different from the previous data
    if (
      previousDataRef.current.amount !== currentData.amount ||
      previousDataRef.current.taxable !== currentData.taxable ||
      previousDataRef.current.pricePer !== currentData.pricePer ||
      JSON.stringify(previousDataRef.current.options) !== JSON.stringify(currentData.options)
    ) {
      // Update the parent component with the new data
      onDataUpdate(currentData);
      
      // Update the previous data ref to the current data
      previousDataRef.current = currentData;
    }
  }, [amount, taxable, pricePer, options, onDataUpdate]);

  return (
    <>
      <h2 >
        Pricing
        </h2>
      <form className="p-4 " 
      style={{ borderTop: '2px solid #004aad', background: '#f4f4f4' }} 
      onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="defaultPrice" className="form-label">Default Price (€)
          </label>
          <input
            type="number"
            id="defaultPrice"
            className="form-control"
            value={amount}
            onChange={(e) => setAmount(parseInt(e.target.value))}
            placeholder=""
          />
        </div>
        <div className="mb-3">
          <label htmlFor="Taxable" className="form-label fw-bold">
            Taxable:</label>
          <select
            id="Taxable"
            className="form-select"
            value={taxable}
            onChange={handleProcedureChange}
          >
            <option value="None">None</option>
            <option value="Option 2">Option 2</option>
            <option value="Option 3">Option 3</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="pricePer" 
          className="form-label fw-bold">
            Price Per:
            </label>
          <select
            id="pricePer"
            className="form-select"
            value={pricePer}
            onChange={handlePricePerChange}
          >
            <option value="">Select Price Per</option>
            <option value="Per Piece">Per Piece</option>
            <option value="Per Pound">Per Pound</option>
            <option value="Per Kilogram">Per Kilogram</option>
            {/* Add more options as needed */}
          </select>
        </div>
        <div className="mb-3">
          <h6>Invoice Options</h6>
          <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="rollUpPrice"
                name="rollUpPrice"
                checked={options.rollUpPrice}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="rollUpPrice">Never roll-up price into procedure</label>
            </div>
          </div>
          <div className="mb-3">
            <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="suppressWhenZero"
                name="suppressWhenZero"
                checked={options.suppressWhenZero}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="suppressWhenZero">Suppress this attribute value when price is zero</label>
            </div>
          </div>
        <div className="mb-3">
          <h6>Report Options</h6>
          <div className="form-check">
              <input
                type="checkbox"
                className="form-check-input"
                id="suppressOnReports"
                name="suppressOnReports"
                checked={options.suppressOnReports}
                onChange={handleChange}
              />
              <label className="form-check-label" htmlFor="suppressOnReports">Suppress this attribute value on reports when price is zero</label>
            </div>
          </div>
      </form>
    </>
  );
}

export default Pricing;
